function formatSecondsToMinutes(seconds) {
  const restSeconds = seconds % 60;
  const minutes = (seconds - restSeconds) / 60;

  return `${minutes.toString().padStart(2, '0')}:${restSeconds.toString().padStart(2, '0')}`;
}

export default {
  formatSeconds: {
    intoMinutes: formatSecondsToMinutes,
  },
};
